import React, { Component } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import Producto from "./producto";
import { ReactComponent as IcoCarrito } from "../../res/iconos/carrito.svg";

function withRouterAndNavigate(Component) {
    function ComponentWithRouterAndNavigate(props) {
      let params = useParams();
      let navigate = useNavigate();
      let location = useLocation();
      return (
        <Component
          {...props}
          params={params}
          navigate={navigate}
          location={location}
        />
      );
    }
    return ComponentWithRouterAndNavigate;
  }

class Detalle extends Component {
  state = {
    imagenes: [],
    imgPaths: [],
    indiceVarianteSeleccionada: null,
  };

  async descargarManual() {
    const res = await fetch(this.state.manualPath);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    this.setState({ manualUrl: url }, () => {
      document.getElementById("botonManual").click();
    });
  }

  async getURLImagen(imgPath) {
    const res = await fetch(imgPath);
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.get()
  }

  get() {
    let datos = this.props.params;
    let newState = {...this.state};
    for (let i in newState) {
      newState[i] = "";
    }
    newState.imagenes = [];
    this.setState(newState, () => {
      fetch(`/api/productos/detalle?categoria=${datos.categoria}&url=${datos.url}`)
      .then((res) => res.json())
      .then(async (data) => {
        const indiceVarianteSeleccionada = data.variantes?.length > 0 ? 0 : null;
        this.setState({...datos, ...data, indiceVarianteSeleccionada}, async () => {
          let i = 0;
          let imagenes = [];
          
          while (i < data.imgPaths?.length) {
            imagenes.push(await this.getURLImagen(data.imgPaths[i].url));
            i++;
          }
          let bannerDesktop = null;
          let bannerMobile = null;;
          if (data.bannerDesktopPath && data.bannerMobilePath) {
            bannerDesktop = await this.getURLImagen(data.bannerDesktopPath);
            bannerMobile = await this.getURLImagen(data.bannerMobilePath);
          }
          this.setState({imagenes, bannerDesktop, bannerMobile});
        })
    })
    })
    
  }

  componentDidUpdate(prevProps) {
    let datos = this.props.params;
    if (prevProps.params.categoria !== datos.categoria || prevProps.params.url !== datos.url) {
      window.scrollTo(0, 0);
      this.get();
    }
  }

  tablaAguaCaliente() {
    const {
      diametroCm, altoCm, capacidadLt,
      potencia, recuperacion,
      conexionAgua,
      energia, tipoGas, 
      aislacion, encendido, instalacion, quemador, eficiencia, termostato
    } = this.state;

    let tabla = [
      {
        nombre: "Ancho",
        valor: diametroCm + " cm"
      },
      {
        nombre: "Alto",
        valor: altoCm + " cm"
      },
      {
        nombre: "Litros",
        valor: capacidadLt + " L"
      },
      {
        nombre: "Potencia",
        valor: potencia + (energia == "g"?" kcal/h":" W")
      },
      {
        nombre: "Recuperación",
        valor: recuperacion + " L/H"
      },
      {
        nombre: "Conexión",
        valor: conexionAgua == 0?"Inferior":conexionAgua==2?"Superior":"Superior e inferior"
      },
      energia == "g"?
      {
        nombre: "Tipo de gas",
        valor: tipoGas
      }:
      {
        nombre: "Tipo de energía",
        valor: "Eléctrico"
      },
      {
        nombre: "Aislación",
        valor: aislacion
      },
      {
        nombre: "Encendido",
        valor: encendido
      },
      {
        nombre: "Instalación",
        valor: instalacion
      },
      energia == "g"?
      {
        nombre: "Quemador",
        valor: quemador
      }:
      {
        nombre: "Termostato",
        valor: termostato?"Si":"No"
      },
      {
        nombre: "Eficiencia energética",
        valor: eficiencia
      },
    ]
    return tabla;
  }

  tablaCocina() {
    const {
      anchoCm, altoCm, profundidadCm, pesoKg,
      potenciaWatts,
      capacidadLt, 
      tempMin, tempMax, nivelesTemp,
      posicionesBandeja, bandejaCoccion, portamigas, rejillaMetalica, luz, conveccion, stayOn, timerMins
    } = this.state;

    let tabla = [
      {
        nombre: "Ancho",
        valor: anchoCm + " cm"
      },
      {
        nombre: "Alto",
        valor: altoCm + " cm"
      },
      {
        nombre: "Profundidad",
        valor: profundidadCm + " cm"
      },
      {
        nombre: "Peso",
        valor: pesoKg + " Kg"
      },
      {
        nombre: "Potencia",
        valor: potenciaWatts + " Watts"
      },
      {
        nombre: "Capacidad",
        valor: capacidadLt + " L"
      },
      {
        nombre: "Temperatura",
        valor: tempMin + "-" + tempMax + " C°"
      },
      {
        nombre: "Niveles de temp.",
        valor: nivelesTemp
      },
      {
        nombre: "Bandeja de cocción",
        valor: bandejaCoccion?"Si":"No"
      },
      {
        nombre: "Posiciones",
        valor: posicionesBandeja
      },
      {
        nombre: "Rejilla metálica",
        valor: rejillaMetalica?"Si":"No"
      },
      {
        nombre: "Bandeja portamigas",
        valor: portamigas?"Si":"No"
      },
      {
        nombre: "Luz interior",
        valor: luz?"Si":"No"
      },
      {
        nombre: "Timer",
        valor: stayOn?"Si (StayOn)":"No"
      },
      {
        nombre: "Tiempo Max.",
        valor: timerMins + " min."
      },
      {
        nombre: "Convección",
        valor: conveccion?"Si":"No"
      },
    ]
    return tabla;
  }

  tablaVytro() {
    const {
      anchoCm, altoCm, profundidadCm, 
      potenciaMinimaWatts, potenciaMaximaWatts, tensionVolts, frecuenciaHz,
      espacioCalefaccionM2, 
      resistencias, largoCableMt, termostato, panel,
      instalacion  
    } = this.state;
    let tabla = [
      {
        nombre: "Ancho",
        valor: anchoCm + " cm"
      },
      {
        nombre: "Alto",
        valor: altoCm + " cm"
      },
      {
        nombre: "Profundidad",
        valor: profundidadCm + " cm"
      },
      {
        nombre: "Potencia mínima",
        valor: potenciaMinimaWatts + " watts"
      },
      {
        nombre: "Potencia máxima",
        valor: potenciaMaximaWatts + " watts"
      },
      {
        nombre: "Tensión",
        valor: tensionVolts + " volts"
      },
      {
        nombre: "Frecuencia",
        valor: frecuenciaHz + " Hz"
      },
      {
        nombre: "Sup. a calefaccionar",
        valor: espacioCalefaccionM2 + " m2*"
      },
      {
        nombre: "Resistencias",
        valor: resistencias,
      },
      {
        nombre: "Cable de alimentación",
        valor: largoCableMt + " metros de largo"
      },
      {
        nombre: "Termostato",
        valor: termostato?"Si":"No"
      },
      {
        nombre: "Panel",
        valor: panel
      },
      {
        nombre: "Colocación",
        valor: instalacion
      }
    ]
    return tabla;
  }

  tablaCalefaccion() {
    const {
      linea,
      anchoCm, altoCm, profundidadCm, 
      kcal, energia,
      espacioCalefaccionM2, 
      tiraje, salidaPosterior, salidaPosteriorLados, salidaLateral, salidaLateralLados, salidaConcentrica,
      encendido, valvula, quemador, camara, instalacion, eficiencia  
    } = this.state;
    let tabla = [
      {
        nombre: "Ancho",
        valor: anchoCm + " cm"
      },
      {
        nombre: "Alto",
        valor: altoCm + " cm"
      },
      {
        nombre: "Profundidad",
        valor: profundidadCm + " cm" + (linea === "Convector Móvil"?" (con soporte garrafa)":"")
      },
      {
        nombre: "Potencia",
        valor: kcal + " kcal/h"
      },
      {
        nombre: "Espacio a calefaccionar",
        valor: espacioCalefaccionM2 + " m2*"
      },
      {
        nombre: "Tipo de tiraje",
        valor: tiraje == 0?"Sin tiraje":tiraje==1?"TB":tiraje==2?'TBU':tiraje==3?"TB/TBU":"Tiro natural",
      },
      {
        nombre: "Tipo de energía",
        valor: energia
      },
      {
        nombre: "Salida posterior",
        valor: salidaPosterior?("Si" + (salidaPosteriorLados?" (Der. o Izq.)":"")):"No"
      },
      {
        nombre: "Salida lateral",
        valor: salidaLateral?("Si" + (salidaLateralLados?" (Der. o Izq.)":"")):"No"
      },
      {
        nombre: "Salida concéntrica",
        valor: salidaConcentrica?"Si":"No"
      },
      {
        nombre: "Encendido",
        valor: encendido
      },
      {
        nombre: "Válvula de seguridad",
        valor: valvula?"Si":"No"
      },
      {
        nombre: "Quemador",
        valor: quemador
      },
      {
        nombre: "Cámara",
        valor: camara
      },
      {
        nombre: "Instalación",
        valor: instalacion
      },
      eficiencia?
      {
        nombre: "Eficiencia energética",
        valor: eficiencia
      }:
      {
        nombre: "Piloto atmosférico",
        valor: "Si"
      },
    ]
    return tabla;
  }

  render() {
    const {modelo, linea, indiceVarianteSeleccionada, imagenes, variantes} = this.state;

    const mobile = window.innerWidth < 950;
    const responsive = {
      todo: { breakpoint: { max: 10000, min: 0 }, items: 1 },
    };
    let categoria;
    let tabla;
    switch (this.props.params.categoria) {
      case "termotanques": categoria = "Agua caliente";
      tabla = this.state.tabla??this.tablaAguaCaliente();
      break;
      case "hornos": categoria = "Cocina - Hornos";
      tabla = this.state.tabla??this.tablaCocina();
      break;
      case "anafes": categoria = "Cocina - Anafes";
      tabla = this.state.tabla??this.tablaCocina();
      break;
      case "campanas": categoria = "Cocina - Campanas";
      tabla = this.state.tabla??this.tablaCocina();
      break;
      default: categoria = "Calefacción";
      if (linea == "Convector Vytro") {
        tabla = this.state.tabla??this.tablaVytro();
      } else {
        tabla = this.state.tabla??this.tablaCalefaccion();
      }
    }
    let imgPaths = this.state.imgPaths?.length > 0 ? this.state.imgPaths : [];

    let imagenesFiltradas;
    if (indiceVarianteSeleccionada != null) {
      imagenesFiltradas = imgPaths.map((img, index) => {
        if (img.indiceVariante == indiceVarianteSeleccionada) {
          return imagenes[index]
        } else {
          return null;
        }
      }).filter((f) => f != null);
    } else {
      imagenesFiltradas = imagenes;
    }

    return (
      <React.Fragment>
        <div style={{width: "100%", height: "4vw"}}/>
        <div style={{width: "80%", marginLeft: "auto", marginRight: "auto"}}>
            <div className="detalle_links">
                <Link to={"/" + (this.props.pais??"")}>Home</Link>
                {" / "}
                <Link to={(this.props.pais?("/"+this.props.pais+"/"):"/") + this.props.params.categoria}>{categoria}</Link>
                {linea && 
                <Link to={(this.props.pais?("/"+this.props.pais+"/"):"/") + this.props.params.categoria + `?linea=${linea}`}>{" / " + linea}</Link>
                }
                {" / "}
                {modelo}
            </div>
            <div style={{height: "3vw"}}/>
            <div style={{display: "flex", width: "100%", height: "fit-content", gap: 60, flexWrap: "wrap", justifyContent: "space-around", justifyItems: "center", alignContent: "stretch", alignItems: "stretch"}}>
                <div style={{flex: 60, minWidth: 250, maxWidth: "min(80%,680px)", width: "100%", minHeight: 100, zIndex: 0}}>
                  <Carousel
                    responsive={responsive}
                    showDots={true}
                    draggable={false}
                    infinite={imagenesFiltradas.length > 1?true:false}
                    autoPlay={true}
                  >
                    {imagenesFiltradas.map((i) => {
                        return (
                          <div
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%"
                            }}
                          >
                            <img
                              alt=""
                              src={i}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        );
                      })}
                  </Carousel>                  
                </div>
                <div style={{flex: 40, gap: 10, display: "flex", flexDirection: "column", justifyContent: "space-between", justifyItems: "space-between", minWidth: 250, maxWidth: 450, width: "100%"}}>
                  <h1 className="detalle_modelo">{this.state.modelo}</h1>
                  {
                    this.state.caracteristicas ?
                    <>
                    <h2 className="detalle_descripcion">{this.state.descripcion}</h2>
                    <h3 className="detalle_calidad">Características de calidad:</h3>
                    <ul className="detalle_calidad_texto">
                        {this.state.caracteristicas?.split("\n").map((c) => 
                        <li>{c}</li>)}
                    </ul>
                    </>
                    :
                    <>
                    <h2 className="detalle_modelo">{this.state.subtitulo1}</h2>
                    <p className="detalle_calidad_texto">{this.state.descripcion}</p>
                    </>
                  }
                  {variantes?.length > 0
                  ?
                  <div>
                    <h4 className="detalle_variantes_titulo">Colores</h4>
                    <h5 className="detalle_variantes_subtitulo">{variantes[indiceVarianteSeleccionada].nombre}</h5>
                    <div className="detalle_variantes_container">
                    {variantes.map((v, i) => 
                      <button className="detalle_variantes_boton" style={{backgroundColor: v.color, outline: i == indiceVarianteSeleccionada ? "2px dashed #41454c" : "",outlineOffset: "3px"}} onClick={() => {this.setState({indiceVarianteSeleccionada: i})}} />
                    )}
                    </div>
                  </div>
                  :
                  <>
                  <div className="detalle_sellos_container">
                    {
                      this.state.garantia && 
                      <img src={require("../../res/iconos/garantia_" + this.state.garantia + ".png")}
                        style={{
    
                          position: "relative",
                          objectFit: "cover",
                          objectPosition: "center",
                          height: 106,
                      }} />
                    }
                  
                    <img src={require("../../res/iconos/calidad.png")}
                      style={{
                        position: "relative",
                        objectFit: "cover",
                        objectPosition: "center",
                        height: 106,
                    }} />
                    {
                      this.state.eficiencia ? 
                      <img src={require("../../res/iconos/eficiencia" + ""/*this.state.eficiencia*/ + ".png")}
                        style={{
                          position: "relative",
                          objectFit: "cover",
                          objectPosition: "center",
                          height: 106,
                      }} /> : <div style={{width: 106, height: 106}}/>
                    }
                  </div>
                  <p className="detalle_legal"><span style={{color: "#9d1c21"}}>*</span>Leer <a href="/informacion-legal">información legal.</a></p>
                  </>
                  }
                  
                  <div className="detalle_botones_container">
                        {this.state.manualPath && 
                        <>
                        <button
                          onClick={() => this.descargarManual()}
                          className="detalle_boton"
                        >
                          Descargar manual
                        </button>
                        <a
                          id="botonManual"
                          href={this.state.manualUrl}
                          download={this.state.manualPath.split("/").slice(-1)}
                          style={{ display: "none" }}
                        />
                        </>
                        }
                        {
                          (false && this.state.linea == "Convector Vytro")
                          ?
                          <Link to={"/" + this.props.params.categoria + "/" + this.props.params.url + "/comprar"}>
                            <button className="detalle_boton_comprar">
                              Comprar
                              <IcoCarrito
                                width={24}
                                height={24}
                              />  
                            </button>
                          </Link>
                          :
                          false && !this.props.pais && 
                          <Link to="/puntos-de-venta.php"><button className="detalle_boton">Dónde comprarlo</button></Link>
                        }
                  </div>
                  {this.state.discontinuado && 
                  <p className="detalle_discontinuado"><span style={{color: "#9d1c21"}}>{"*Producto discontinuado: "}</span>consultar stock en su comercio más cercano.</p>}
                </div>
            </div>
          </div>
            {
              this.state.bannerDesktop && this.state.bannerMobile &&
              <>
              <div style={{height: "6vw"}}/>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  //height: 300,
                }}
              >
                <img
                  src={mobile?this.state.bannerMobile:this.state.bannerDesktop}
                  style={{
                    position: "relative",
                    objectFit: "cover",
                    objectPosition: "center",
                    width: "100%",
                    //height: 300,
                    zIndex: -1,
                  }}
                />
              </div>
              </>
            }
          <div style={{width: "80%", marginLeft: "auto", marginRight: "auto"}}>  
            <div style={{height: "6vw"}}/>
            {
              this.state.modelo?.length > 0 ?
                Array.isArray(tabla) ? 
                <>
                <h1 className="detalle_seccion">Información técnica</h1>
                <div className="detalle_tabla">
                {tabla?.map((c) => {
                  return (
                    <div className="detalle_campo">
                      <h4 className="detalle_campo_nombre">{c.nombre}</h4>
                      <p className="detalle_campo_valor">{c.valor}</p>
                    </div>
                  );
                })}
                </div>
                </>
                :
                <table className="detalle_table">
                  <tbody className="detalle_tbody">
                    {Object.keys(tabla).map(c => {
                      let valor = tabla[c];
                      if (Array.isArray(tabla[c])) {
                        valor = tabla[c].join("\n");
                      };
                      const variables = valor.match(/{\{([^:]+):([^}]+)\}\}/);
                      let icono;
                      if (variables?.[1] == 'icono') {
                        icono = variables[2];
                      }
                      valor = valor.replace(/{\{([^:]+):([^}]+)\}\}/,"");
                      return <tr className="detalle_tr">
                        <th className="detalle_th">{c}</th>
                        <td className="detalle_td">
                          {valor}
                          {icono && 
                          <img style={{width: "100%"}} src={require(`../../res/iconos/${icono}`)}/>}
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table>
              :
              <></>
            }
            
            {(this.state.categoria == "calefaccion" || this.state.linea == "Convector Vytro" || this.state.modelo == "Hotspot") && 
            <p className="detalle_aclaracion">*Se considera una altura de techo de 2,70 mts del espacio a calefaccionar.</p>
            } 
            <div style={{height: "3vw"}}/>
            {
              this.state.relacionados?.length > 0 && 
              <>
              <h1 className="detalle_seccion">Productos relacionados</h1>
              <div style={{display: "flex", flexWrap: "wrap", width: "100%", gap: 24, justifyContent: "center", alignContent: "center", alignItems: "center"}}>
                {this.state.relacionados.map((p,i) => 
                <Producto key={`card_producto_${this.state.id}_${i}`} producto={p} setUrl={() => {}}/>)}
              </div>
              </>
            }
        </div>
        
        <div style={{width: "100%", height: "7vw"}}/>
      </React.Fragment>
    );
  }
}

export default withRouterAndNavigate(Detalle);
